export const getData = (state) => {
  return state;
};

export const getBalance = (state) => {
  const toNumber = (val) => {
    if (typeof val === "string") {
      return Number(
        val.replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", ".")
      );
    }
    return val;
  };

  // shortened variables
  const finVolume = toNumber(state.symbol1FinVolume);

  const qtdVolume1 = state.symbol1QtdVolume;
  const qtdVolume2 = state.symbol2QtdVolume;

  const price1 = state.symbol1Price;
  const price2 = state.symbol2Price;

  const step1 = state.symbol1Step;
  const step2 = state.symbol2Step;

  const operation = state.operationType;
  if (state.volumeType === "FIN_VOLUME") {
    // normalized quantities (according to min volume)
    const toNormalizedQuantity = (volume, price, step) => {
      return volume / price - ((volume / price) % step);
    };
    const toNormalizedQuantity1 = toNormalizedQuantity(
      finVolume,
      price1,
      step1
    );
    const toNormalizedQuantity2 = toNormalizedQuantity(
      finVolume,
      price2,
      step2
    );

    const priceFromNormalized1 = toNormalizedQuantity1 * price1;
    const priceFromNormalized2 = toNormalizedQuantity2 * price2;

    const balance = () => {
      if (operation === "Compra") {
        return priceFromNormalized2 - priceFromNormalized1;
      } else if (operation === "Venda") {
        return priceFromNormalized1 - priceFromNormalized2;
      }
      return 0;
    };

    return balance();
  } else if (state.volumeType === "QUANTITY") {
    const balance = () => {
      if (operation === "Compra") {
        return qtdVolume2 * price2 - qtdVolume1 * price1;
      } else if (operation === "Venda") {
        return qtdVolume1 * price1 - qtdVolume2 * price2;
      }
      return 0;
    };

    return balance();
  }
  return 0;
};

export const getQtdFromFin1 = (state) => {
  if (state.volumeType === "FIN_VOLUME") {
    // currency string formatter
    const toNumber = (val) => {
      if (typeof val === "string") {
        return Number(
          val.replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", ".")
        );
      }
      return val;
    };

    // shortened variables
    const finVolume = toNumber(state.symbol1FinVolume);

    const price1 = state.symbol1Price;

    const step1 = state.symbol1Step;

    // normalized quantities (according to min volume)
    const toNormalizedQuantity = (volume, price, step) => {
      return volume / price - ((volume / price) % step);
    };
    const toNormalizedQuantity1 = toNormalizedQuantity(
      finVolume,
      price1,
      step1
    );

    return toNormalizedQuantity1 || 0;
  } else if (state.volumeType === "QUANTITY") {
    const qtdVolume = state.symbol1QtdVolume;

    const price1 = state.symbol1Price;

    const step1 = state.symbol1Step;

    // normalized quantities (according to min volume)
    const toNormalizedQuantity = (volume, price, step) => {
      return volume / price - ((volume / price) % step);
    };
    const toNormalizedQuantity1 = toNormalizedQuantity(
      qtdVolume,
      price1,
      step1
    );
    return toNormalizedQuantity1 || 0;
  }
  return 0;
};

export const getQtdFromFin2 = (state) => {
  if (state.volumeType === "FIN_VOLUME") {
    // currency string formatter
    const toNumber = (val) => {
      if (typeof val === "string") {
        return Number(
          val.replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", ".")
        );
      }
      return val;
    };

    // shortened variables
    const finVolume = toNumber(state.symbol1FinVolume);

    const price2 = state.symbol2Price;

    const step2 = state.symbol2Step;

    // normalized quantities (according to min volume)
    const toNormalizedQuantity = (volume, price, step) => {
      return volume / price - ((volume / price) % step);
    };
    const toNormalizedQuantity2 = toNormalizedQuantity(
      finVolume,
      price2,
      step2
    );

    return toNormalizedQuantity2 || 0;
  }
  return 0;
};
